interface Props {
    errorMessage: string;
}

export default function FormErrorMessage({ errorMessage }: Props){
    return(
        <div className="col-sm-12 alert alert-danger" hidden={!errorMessage}>
            {errorMessage}
        </div>
    )
}